import { useEffect, useMemo, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownCard } from 'shared/ui'
import type { Contact } from 'entities/Contacts/model/Contact'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { WorkflowEnrollStore } from 'widgets/WorkflowEnroll/store/WorkflowEnrollStore'

import styles from './styles.module.scss'

type IWorkflowEnrollDropdownItemProps = {
  contact: Contact
  onClick: () => void
}

export const WorkflowEnrollDropdownItem: FC<IWorkflowEnrollDropdownItemProps> = observer(
  ({ contact, onClick }) => {
    const entities = useEntitiesContext()
    const store = useMemo(() => new WorkflowEnrollStore(entities), [])
    const blockReason = store.getBlockReason(contact)

    useEffect(() => store.checkActivity(), [])

    return (
      <DropdownCard
        item={{
          id: 'workflow',
          label: 'Enroll in workflow',
          iconL: 'workflows',
          disabled: !!blockReason,
          tooltipProps: {
            placement: 'left-start',
            label: blockReason,
            className: styles.tooltip,
          },
        }}
        onChange={() => {
          onClick()
          store.enrollContacts([contact.id])
        }}
      />
    )
  }
)
